import Link from "next/link";
import { Button } from "@/components/ui/button";
import { resolveLink } from "@/lib/utils";

const PRIMARY_BUTTON_COLORS = {
  background: "#892102", // red gum
  foreground: "#FFFFFF",
};

function resolveButtonVariant(style) {
  const value = typeof style === "object" ? style?.value : style;
  if (value === "outline") return "outline";
  return "default";
}

function resolveCustomColors(item, variant) {
  if (item?.use_custom_colours) {
    return {
      background: item?.custom_button_background_color,
      foreground: item?.custom_button_foreground_color,
    };
  }
  // Default filled buttons use 2026 primary (red gum), not theme orange
  if (variant === "default") {
    return PRIMARY_BUTTON_COLORS;
  }
  return undefined;
}

/** Bard / replicator button → theme primary (or outline) with optional CMS colour overrides */
export function ContentButtonLink({ item, className }) {
  if (!item) return null;

  const variant = resolveButtonVariant(item?.button_style);

  return (
    <Button
      variant={variant}
      customColors={resolveCustomColors(item, variant)}
      className={className}
      asChild
    >
      <Link
        target={item?.open_in_new_window_tab ? "_blank" : "_self"}
        href={resolveLink(item?.url) ?? "#"}
      >
        {item?.button_title}
      </Link>
    </Button>
  );
}
